import React, { Component } from 'react';
import Navbar from '../components/navbar/navbar'
import NavbarTransparent from '../components/NavbarTransparent/NavbarTransparent'
import Footer from '../components/Footer/Footer'
import './App.css';
import { withRouter } from 'react-router-dom'

class App extends Component {

  render() {
    const { pathname } = this.props.location
    return (
      <div>
        {pathname === '/' ? <NavbarTransparent /> : <Navbar />}
        {
          this.props.children
        }
        <Footer />
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/pages/App.js